import { environment } from 'src/environments/environment.dev';
import { Injectable } from '@angular/core';
import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest
} from '@angular/common/http';
import { catchError, Observable, switchMap, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from './demo/service/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private excludedUrls: string[] = [
        `/`,
        `/auth/selfcare/login`,
        `/auth/refresh-token`,
        `/enrolment/signup`,
        `/auth/password-reset`,
        '/metadata/countries',
        '/selfcare/identification-types',
    ];

    constructor(private authService: AuthService, private router: Router) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

       const isExcluded = this.excludedUrls.indexOf(req.url) !== -1;

        if (isExcluded) {
            return next.handle(req);
        }

        const accessToken = this.authService.getAccessToken();
        if (accessToken) {
            req = req.clone({
              setHeaders: { Authorization: `Bearer ${accessToken}` },
            });
        }

        return next.handle(req).pipe(
            catchError(error => {

              if (error.status === 401 || error.status === 0) {
                return this.authService.refreshToken().pipe(
                  switchMap(newToken => {
                    req = req.clone({

                      setHeaders: { Authorization: `Bearer ${this.authService.getAccessToken()}` },
                    });

                    return next.handle(req);
                  }),
                  catchError(refreshError => {

                    this.authService.logout();
                    return throwError(() => new Error('Session expired. Please log in again.'));
                  })
                );
              }
              return throwError(() => error);
            })
          );
        }
}

